module.exports = __webpack_public_path__ + "media/images/thumbs/linkassignment/ohap_assignments_link-e3e31cd19919a071c903d4b5f36af3d7.png";